import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Personne } from 'src/app/model/call/call.model';
import { Installation } from 'src/app/model/installation/installation.model';
import { Installee } from 'src/app/model/installations/installee.model';
import { Personnes, SavSuivi } from 'src/app/model/suiviCall/suiviCall';
import { CallService } from 'src/app/services/http/call/call.service';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
@Component({
  selector: 'app-new-call',
  templateUrl: './new-call.component.html',
  styleUrls: ['./new-call.component.scss']
})
export class NewCallComponent implements OnInit {

  @Input() suiviId !: number;

  public formInstall!: FormGroup;

  public installations!: Installee[];

  public selectedInstallation!: Installee | undefined;

  public filteredInstallations!: Installee[];

  public installationDetails!: Installation;
  public loading!: boolean;
  codesPannes: string[] = [];
  snMachine!: string;

  detailAppel : SavSuivi = new SavSuivi;


  constructor(private formBuilder: FormBuilder, private installationsService: InstallationsService, private service: CallService) { }

  ngOnInit(): void {

    this.installationsService.getInstallations()
      .subscribe((installations) => {
        this.installations = installations.en_service;
        this.filteredInstallations = this.installations;

        if (this.suiviId > 0) {

          this.service.getCallsDetailsData((this.suiviId.toString())).subscribe((detailAppel) => {
            this.detailAppel = detailAppel;
            this.setInstallation(detailAppel.id_installation);
          })
    
        }
      });

    this.formInstall = this.formBuilder.group({
      installation: ['']
    });

  }

  /** Handler so that user can filter the installations select by typing characters in the select search field  */
  onKey(event: any) {
    this.filteredInstallations = this.searchInstalls(event.target.value);
  }

  /** Filtrer les installations en cherchant dans le nom de l'installation, le propiétaire, et la ville  */
  searchInstalls(value: string) {
    let filter = value.toLowerCase();
    return this.installations.filter(install =>
      install.nom_installation.toLowerCase().includes(filter)
      || install.societe_proprietaire_raison_sociale.toLowerCase().includes(filter)
      || install.adresse_ville.toLowerCase().includes(filter)
      || install.adresse_pays.toLowerCase().includes(filter)
      || install.numero_serie.toLowerCase().includes(filter)
      );
  }

  getInstallation(event: any) {
    this.loading = true;
    this.installationsService.getInstallation(event.value.id_installation)
      .subscribe((installation) => {
        this.installationDetails = installation;
        this.snMachine = installation.machine.numero_serie;
        this.loading = false;
      });
  }

  getPannesForComposant(event: any) {
    if (event) {
      this.codesPannes = event.codes_pannes;
    } else {
      this.codesPannes = [];
    }
  }

  resetSelectedMachine(event: any) {
    if (event) {
      this.selectedInstallation = undefined;
    }
  }

  setInstallation(id: number) {
    this.installationsService.getInstallation(id.toString())
      .subscribe((installation) => {
        this.installationDetails = installation;
        this.snMachine = installation.machine.numero_serie;
        this.loading = false;
      });
    if (this.installations) {
      this.selectedInstallation = this.installations.filter(
        install =>
          install.id_installation == id
      )[0];
    }
  }
}
